/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/state-in-constructor */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import {
  CaretRightOutlined,
  ContainerOutlined,
  FormOutlined,
  LineChartOutlined,
  LoadingOutlined,
  LogoutOutlined,
  NotificationOutlined,
  RetweetOutlined,
  SafetyOutlined,
  SettingOutlined,
  ShopOutlined,
  UserOutlined,
} from '@ant-design/icons';
import CheckAuth from 'components/common/CheckAuth';
import authorities from 'helpers/authorities';
import logo from 'assets/images/static/logo.png';
import user from 'assets/images/static/user.svg';

import { AuthContext } from 'context/AuthContext';
import authService from 'services/auth.services';
import VKNSelector from '../common/VKNSelector';
import roles from '../../helpers/roles';

const { Sider } = Layout;

class Sidebar extends React.Component {
  constructor(props, context) {
    super(props, context);
    const pathname = props?.location?.pathname;
    let activeItem = null;
    if (pathname.includes('basvurular')) {
      activeItem = 'applications';
    } else if (pathname.includes('raporlar')) {
      activeItem = 'reports';
    } else if (pathname.includes('odemeler-ve-faturalar')) {
      activeItem = 'payments';
    }
    this.state = {
      show: false,
      open: false,
      selectedValue: null,
      activeItem,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.bodyClickListener = this.handleBodyClick.bind(this);
    document.body.removeEventListener('click', this.bodyClickListener);
    
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', document.body);
  }

   handleLogout() {
    const { navigate } = this.props;
    authService.logout();
    navigate('/login');
  }

  toggleMenu = (e) => {
    e.stopPropagation(); // Olayın yayılmasını durdur
    this.setState(
      (prevState) => ({ show: !prevState.show }),
      () => {
        console.log('Güncellenmiş show değeri:', this.state.show);
      },
    );
  };

  handleOpenVKN = () => {
    this.setState({ open: true });
  };

  handleCloseVKN = () => {
    this.setState({ open: false });
  };

  handleSelectedMerchChange = (value) => {
    const parsedValue = JSON.parse(value);
    this.setState({ selectedValue: parsedValue });
  };

  handleSubmit = () => {
    const { changeSelectedMerch } = this.context;
    const { selectedValue } = this.state;
    changeSelectedMerch(selectedValue);
    this.handleCloseVKN();
  };

  setActiveItem = (item) => {
    this.setState({ activeItem: item });
  };

  handleBodyClick = (e) => {
    const id = e?.target?.id;
    if (id !== 'settings' && id !== 'toggle-menu') {
      if (this.unmounted) {
        this.setState({ show: false });
      }
    }
  };

  render() {
    const { show, open, activeItem } = this.state;
    const { currentUser, currentUserMerchs, selectedMerch, loading } = this.context;
    const userRole = currentUser?.role?.name;
    return (
      <Sider className="sider" width="270">
        <div className="buttons">
          <div className="logo">
            {userRole !== roles.PAYE_ADMIN ? (
              <CheckAuth authorityCode={authorities.DISPLAY_DASHBOARD}>
                <NavLink to="/dashboard">
                  <img src={logo} alt="Paye Kart" />
                  <span>ÜYE İŞYERLERİ</span>
                </NavLink>
              </CheckAuth>
            ) : (
              <CheckAuth authorityCode={authorities.DISPLAY_ALL_RECORDS_ANNOUNCEMENTS}>
                <NavLink to="/duyurular">
                  <img src={logo} alt="Paye Kart" />
                  <span>ÜYE İŞYERLERİ</span>
                </NavLink>
              </CheckAuth>
            )}
          </div>
          <div className="collapse" onClick={this.toggleMenu} id="toggle-menu">
            <SettingOutlined className={`${this.state.show ? 'active' : ''}`} id="settings" />
          </div>
          <div className={`sub-menu ${show ? 'show' : ''}`}>
            <ul>
              <CheckAuth authorityCode={authorities.DISPLAY_ALL_RECORDS_MERHANT_INFO}>
                <li>
                  <NavLink to="/is-yeri-bilgilerim">
                    <ShopOutlined />
                    <span>Üye İşyerlerim</span>
                  </NavLink>
                </li>
              </CheckAuth>
              <CheckAuth authorityCode={authorities.DISPLAY_INFORMATION_USER}>
                <li>
                  <NavLink to="/kullanici-bilgileri">
                    <ShopOutlined />
                    <span>Kullanıcı Bilgileri</span>
                  </NavLink>
                </li>
              </CheckAuth>
              <li>
                <a href="#" onClick={this.handleOpenVKN}>
                  <RetweetOutlined />
                  <span>Firma Değiştir</span>
                </a>
              </li>
              <li>
                <a href="#" className="logout" onClick={this.handleLogout}>
                  <LogoutOutlined />
                  <span>Çıkış</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        {userRole !== roles.PAYE_ADMIN ? (
          <div className="profile">
            <div className="avatar">
              <img src={user} alt="Default Avatar" />
            </div>

            {loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />}
            {!loading && (
              <div className="info">
                <span className="name">{currentUser?.email}</span>
                <span className="role">Rol: {currentUser?.role?.name || ''}</span>
                <span className="vkn" onClick={this.handleOpenVKN}>
                  <span>
                    Firma Seç: {` ${selectedMerch?.number || ''} `}
                    <i className="fa fa-arrow-down" />
                  </span>
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className="profile">
            <div className="avatar">
              <img src={user} alt="Default Avatar" />
            </div>
            <div className="info">
              <span className="name">{currentUser?.email}</span>
              <span className="role">Rol: {currentUser?.role?.name}</span>
            </div>
          </div>
        )}

        <div className="menu">
          <ul>
            <CheckAuth authorityCode={authorities.DISPLAY_ALL_RECORDS_SUB_USERS}>
              <li>
                <NavLink to="/kullanici-islemleri">
                  <UserOutlined />
                  <span>Alt Kullanıcı İşlemleri</span>
                  <CheckAuth />
                </NavLink>
              </li>
            </CheckAuth>

            <CheckAuth authorityCode={authorities.DISPLAY_ALL_RECORDS_BRANCHS}>
              <li>
                <NavLink
                  to="/subeler"
                  onClick={() => {
                    this.setActiveItem('');
                  }}
                >
                  <ShopOutlined />
                  <span>Şube İşlemleri</span>
                </NavLink>
              </li>
            </CheckAuth>

            <CheckAuth
              authorityCode={
                authorities.EOD_REPORT ||
                authorities.CURRENT_ACCOUNT_REPORT ||
                authorities.BABS_REPORT
              }
            >
              <li>
                <a
                  className={activeItem === 'reports' ? 'active' : ''}
                  onClick={() => {
                    this.setActiveItem('reports');
                  }}
                >
                  <LineChartOutlined />
                  <span>Raporlar</span>
                  <CaretRightOutlined className="caret" />
                </a>
                <ul className={activeItem === 'reports' ? 'active' : ''}>
                  <CheckAuth authorityCode={authorities.EOD_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('reports');
                      }}
                    >
                      <NavLink to="/raporlar/sube-bazli-gun-sonu-raporu">
                        <span>Günsonu Raporları</span>
                      </NavLink>
                    </li>
                  </CheckAuth>
                 {/*
                <CheckAuth authorityCode={authorities.CURRENT_ACCOUNT_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('reports');
                      }}
                    >
                      <NavLink to="/raporlar/cari-hesap-raporu">
                        <span>Cari Hesap Raporu</span>
                      </NavLink>
                    </li>
                  </CheckAuth>
                  <CheckAuth authorityCode={authorities.BABS_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('reports');
                      }}
                    >
                      <NavLink to="/raporlar/babs">
                        <span>BA-BS Raporu</span>
                      </NavLink>
                    </li>
                  </CheckAuth> */}
                </ul>
              </li>
            </CheckAuth>

            <CheckAuth
              authorityCode={
                authorities.PAYMENT_REPORT ||
                authorities.INVOICE_REPORT ||
                authorities.PAYE_INVOICE_REPORT
              }
            >
              <li>
                <a
                  className={activeItem === 'payments' ? 'active' : ''}
                  onClick={() => {
                    this.setActiveItem('payments');
                  }}
                >
                  <ContainerOutlined />
                  <span>Ödemeler ve Faturalar</span>
                  <CaretRightOutlined className="caret" />
                </a>
                <ul className={activeItem === 'payments' ? 'active' : ''}>
                  <CheckAuth authorityCode={authorities.PAYMENT_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('payments');
                      }}
                    >
                      <NavLink to="/odemeler-ve-faturalar/odemeler">
                        <span>Ödemeler</span>
                      </NavLink>
                    </li>
                  </CheckAuth>
                  <CheckAuth authorityCode={authorities.INVOICE_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('payments');
                      }}
                    >
                      <NavLink to="/odemeler-ve-faturalar/tarafima-kesilen-faturalar">
                        <span>Tarafımdan Kesilen Faturalar</span>
                      </NavLink>
                    </li>
                  </CheckAuth>
                  <CheckAuth authorityCode={authorities.PAYE_INVOICE_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('payments');
                      }}
                    >
                      <NavLink to="/odemeler-ve-faturalar/paye-tarafindan-kesilen-faturalar">
                        <span>Paye Tarafından Kesilen Faturalar</span>
                      </NavLink>
                    </li>
                  </CheckAuth>

                  <CheckAuth authorityCode={authorities.PAYE_INVOICE_REPORT}>
                    <li
                      onClick={() => {
                        this.setActiveItem('payments');
                      }}
                    >
                      <NavLink to="/odemeler-ve-faturalar/faturaya-dahil-edilmeyen-islemler">
                        <span>Faturaya Dahil Edilmeyen İşlemler</span>
                      </NavLink>
                    </li>
                  </CheckAuth>
                </ul>
              </li>
            </CheckAuth>

          {/*  <CheckAuth authorityCode={authorities.APPLICATIONS}>
              <li>
                <a
                  className={activeItem === 'applications' ? 'active' : ''}
                  onClick={() => {
                    this.setActiveItem('applications');
                  }}
                >
                  <FormOutlined />
                  <span>Başvurular</span>
                  <CaretRightOutlined className="caret" />
                </a>
                <ul className={activeItem === 'applications' ? 'active' : ''}>
                  <li
                    onClick={() => {
                      this.setActiveItem('applications');
                    }}
                  >
                    <NavLink to="/basvurular/yeni-sube-basvurusu">
                      <span>Yeni Şube Başvurusu</span>
                    </NavLink>
                  </li>
                  <li
                    onClick={() => {
                      this.setActiveItem('applications');
                    }}
                  >
                    <NavLink to="/basvurular/yeni-terminal-basvurusu">
                      <span>Yeni Terminal Başvurusu</span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            </CheckAuth> */}

            <CheckAuth authorityCode={authorities.DISPLAY_ALL_RECORDS_ROLE}>
              <li>
                <NavLink
                  to="/izinler"
                  onClick={() => {
                    this.setActiveItem('');
                  }}
                >
                  <SafetyOutlined />
                  <span>Roller</span>
                </NavLink>
              </li>
            </CheckAuth>

            <CheckAuth authorityCode={authorities.DISPLAY_ALL_RECORDS_ANNOUNCEMENTS}>
              <li>
                <NavLink
                  to="/duyurular"
                  onClick={() => {
                    this.setActiveItem('');
                  }}
                >
                  <NotificationOutlined />
                  <span>Duyurular</span>
                </NavLink>
              </li>
            </CheckAuth>
          </ul>
        </div>
        {open && (
          <VKNSelector
            currentUserMerchs={currentUserMerchs}
            selectedMerch={selectedMerch}
            open={open}
            onOk={this.handleSubmit}
            onCancel={this.handleCloseVKN}
            onChange={this.handleSelectedMerchChange}
          />
        )}
      </Sider>
    );
  }
}

Sidebar.contextType = AuthContext;

Sidebar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
};

const SidebarWrapper = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  return <Sidebar {...props} location={location} navigate={navigate} />;
};

export default SidebarWrapper;
